export const getFormattedFileName = (path, extension) => {
  const name = path.substr(0, path.lastIndexOf("."));
  return `${name}.${extension}`;
};